<template>
  <n-date-picker v-if="editable" :value="pickerValue" @update:value="onUpdateValue" :type="type" :placeholder="placeholder" />
  <div v-if="!editable" class="content flex-row-nowrap-start-start-center">{{ content }}</div>
</template>
<script lang="ts" setup>
import { yyyymmdd } from "@/util/timeUtil"
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    value: number | Array<number>
    placeholder?: string
    type: string
    editable?: boolean
  }>(),
  {
    type: "date",
    editable: false,
  }
)
const emits = defineEmits<{
  "update:value": [value: number | Array<number>]
}>()

const pickerValue = computed(() => {
  if (props.value == 0) {
    return null
  }
  return props.value
})

const onUpdateValue = (value: number | Array<number>) => {
  emits("update:value", value)
}

const content = computed(() => {
  if (!props.value || props.value == 0) {
    return "未设置"
  }
  switch (props.type) {
    case "date":
      return yyyymmdd(props.value as number)
    case "daterange":
      return `${yyyymmdd((props.value as Array<number>)[0])} 至 ${yyyymmdd((props.value as Array<number>)[1])}`
    default:
      return "unknown"
  }
})
</script>
<style scoped>
.content {
  min-height: 34px;
}
</style>
